/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, DialogTitle } from "@mui/material";

export const StyledDialogTitle = styled(DialogTitle)({
  '&.MuiDialogTitle-root': {
    padding: '0px 24px'
  },
})
